import styled from "@emotion/styled";
import { Modal, modalClasses } from "@kaltura/ds-react-components";

export const StyledCreatePlaylistModal = styled(Modal)(({ theme }) => ({
    [`& .${modalClasses.paper}`]: {
        [theme.breakpoints.up(theme.breakpoints.values.sm)]: {
            minWidth: 584,
            maxWidth: 584,
            maxHeight: "70vh",
        },
    },
}));
